const reviewsSelection = document.querySelector(".js-reviews-selection-filling-init");

if (reviewsSelection) {
    window.addEventListener("load", reviewsSelectionFillingInit());
}

function reviewsSelectionFillingInit() {
    const reviewsSelectionItems = reviewsSelection.querySelectorAll(".js-reviews-selection-item");
    reviewsSelectionItems.forEach((item) => {
        const itemValue = item.querySelector(".js-reviews-selection-value");
        const itemScaleBg = item.querySelector(".js-reviews-selection-scale-bg");
        itemScaleBg.style.width = itemValue.textContent;
    });
}
